import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "MaxAmountModal" */ /* webpackPrefetch: true */
      './MaxAmountModal.component'
    ),
);
